import React from 'react'
// import React,{useState} from 'react'
import SelectLanes from './SelectLanes'
import BenchMarkResults from './BenchMarkResults'
import {Container,Column} from '../../Shared/FlexDiv/FlexDiv'
// import {Row,Container,Column} from '../../Shared/FlexDiv/FlexDiv'
import classes from './BenchmarkMasterView.module.css'
// import Modal from '../../PopupModal'
// import FeedbackForm from '../BenchmarkMasterView/RatingsandFeedback'
// import Uploads from './Uploads'
// import { isMobile } from '../../../Constants'
// import { CommonModal } from '../Utility'
const BenchmarkMasterView = ({
    currentLaneList=[],
    updateCurrentLaneList,
    allowedSessions=0,
    selectedLane,
    allowedrate,
    setallowedrate,
    setallowedtransporter,
    allowedtransporter,
    handleChange,
    setSelectedLane,
    allowedLanes=0,
    togglerates,
    maxlanes,
    setTogglerates ,
    toggleLoader,
    getSessionID,
    // setUserData,
    LSPCollapsed,
    setLSPCollapsed,
    lspLanes,
    setLspLanes,
    history=[],
    qualitativeInputs={},
    setqualitativeInputs,
    activeStep,
    setActiveStep,
    // userDataObject,
    resetData,
    toggleNav,
    collapsed,
    setCollapsed,
    sessionid,
    setSessionid,
    onCalendlyScheduled
}) => {

const switcher=()=>{
switch(activeStep){
    case 0 :return <SelectLanes 
                    history={history} 
                    allowedLanes={allowedLanes}
                    qualitativeInputs = {qualitativeInputs}
                    // setUserData={setUserData} 
                    maxlanes={maxlanes}
                    toggleLoader={toggleLoader} 
                    setSessionID={setSessionid} 
                    getResults={setActiveStep} 
                    getSessionID={getSessionID}
                    currentLaneList={currentLaneList} 
                    updateCurrentLaneList={updateCurrentLaneList}
                    allowedSessions={allowedSessions}
                    toggleNav={toggleNav}
                    collapsed={collapsed}

                    />
    case 1:return <BenchMarkResults 
                    history={history} 
                    togglerates = {togglerates}
                    setTogglerates = {setTogglerates} 
                    // setUserData={setUserData} 
                    toggleLoader={toggleLoader} 
                    sessionid={sessionid} 
                    allowedrate={allowedrate}
                    setallowedrate={setallowedrate}
                    allowedtransporter={allowedtransporter}
                    setallowedtransporter={setallowedtransporter}
                    currentLaneList={currentLaneList}
                    updateCurrentLaneList={updateCurrentLaneList}
                    setActiveStep={setActiveStep}
                    setSessionid={setSessionid}
                    setqualitativeInputs={setqualitativeInputs}
                    // collapsed = {collapsed}
                    setCollapsed = {setCollapsed}
                    LSPCollapsed = {LSPCollapsed}
                    setLSPCollapsed = {setLSPCollapsed}
                    lspLanes = {lspLanes}
                    setLspLanes = {setLspLanes} 
                    qualitativeInputs={qualitativeInputs}
                    resetData={resetData}
                    toggleNav={toggleNav}
                    collapsed={collapsed}
                    allowedSessions={allowedSessions}
                    selectedLane={selectedLane}
                    handleChange={handleChange}
                    setSelectedLane={setSelectedLane}
                    onCalendlyScheduled={onCalendlyScheduled}
                    />
    default:return <>Nothing to Show</>    

}
}
    return (
        <Container className={classes['margin-left']}>
            <Column className={classes['margin-right']}>
                {
                    switcher()
                }
            </Column>
        </Container>
    )
}


export default BenchmarkMasterView
